"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.typo = void 0;
var styled_components_1 = require("styled-components");
var modularscale_js_1 = __importDefault(require("modularscale-js"));
var mixins_1 = require("./mixins");
var colors_1 = require("./colors");
var utilsOolib_1 = require("../utilsOolib");
var white = colors_1.colors.white, greyColor40 = colors_1.colors.greyColor40, greyColor80 = colors_1.colors.greyColor80;
var msW = function (n) {
    var modularscale = {
        base: [10.24, 14],
        ratio: 1.25,
    };
    return (0, modularscale_js_1.default)(n, modularscale);
};
//replace with new fonts here.
var serif = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: 'noto_serif', 'noto_sans_devanagari', 'noto_sans_gu',\n    'noto_sans_te', 'noto_sans_kn', 'noto_sans_or', sans-serif;\n"], ["\n  font-family: 'noto_serif', 'noto_sans_devanagari', 'noto_sans_gu',\n    'noto_sans_te', 'noto_sans_kn', 'noto_sans_or', sans-serif;\n"])));
var sansSerif = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: 'noto_sans', 'noto_sans_devanagari', 'noto_sans_gu',\n    'noto_sans_te', 'noto_sans_kn', 'noto_sans_or', sans-serif;\n"], ["\n  font-family: 'noto_sans', 'noto_sans_devanagari', 'noto_sans_gu',\n    'noto_sans_te', 'noto_sans_kn', 'noto_sans_or', sans-serif;\n"
    // const serif = css`
    //   font-family: 'noto_serif', 'noto_sans_devanagari', 'noto_sans_gu',
    //     'noto_sans_te', 'noto_sans_kn', 'noto_sans_or', sans-serif;
    // `
    // const sansSerif = css`
    //   font-family: 'noto_sans', 'noto_sans_devanagari', 'noto_sans_gu',
    //     'noto_sans_te', 'noto_sans_kn', 'noto_sans_or', sans-serif;
    // `
])));
var fontCss = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: ", ";\n  font-style: ", ";\n  text-decoration: ", ";\n  text-transform: ", ";\n  color: ", ";\n"], ["\n  font-weight: ", ";\n  font-style: ", ";\n  text-decoration: ", ";\n  text-transform: ", ";\n  color: ", ";\n"])), function (_a) {
    var fontWeight = _a.fontWeight;
    return fontWeight || '';
}, function (_a) {
    var fontStyle = _a.fontStyle;
    return fontStyle || '';
}, function (_a) {
    var textDecoration = _a.textDecoration;
    return textDecoration || '';
}, function (_a) {
    var textTransform = _a.textTransform;
    return textTransform || '';
}, function (_a) {
    var color = _a.color, invert = _a.invert;
    return (invert ? white : color);
});
var SANS_0 = (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(2), "px");
        default:
            return "".concat(msW(0), "px");
    }
}, sansSerif, fontCss);
var SANS_2 = (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.7em;\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: 1.7em;\n  ", "\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(3), "px");
        default:
            return "".concat(msW(2), "px");
    }
}, fontCss, sansSerif);
var SANS_3 = (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.5em;\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: 1.5em;\n  ", "\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(4), "px");
        default:
            return "".concat(msW(3), "px");
    }
}, fontCss, sansSerif);
var SANS_3_4 = (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.7em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-size: ", ";\n  line-height: 1.7em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(4), "px");
        default:
            return "".concat(msW(3), "px");
    }
}, fontCss, sansSerif, (0, mixins_1.mediaQuery)('md'), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(5), "px");
        default:
            return "".concat(msW(4), "px");
    }
});
var SANS_4 = (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(5), "px");
        default:
            return "".concat(msW(4), "px");
    }
}, fontCss, sansSerif);
var SANS_4_5 = (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(5), "px");
        default:
            return "".concat(msW(4), "px");
    }
}, fontCss, sansSerif, (0, mixins_1.mediaQuery)('md'), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(6), "px");
        default:
            return "".concat(msW(5), "px");
    }
});
var SANS_5_6 = (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(6), "px");
        default:
            return "".concat(msW(5), "px");
    }
}, fontCss, sansSerif, (0, mixins_1.mediaQuery)('md'), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(7), "px");
        default:
            return "".concat(msW(6), "px");
    }
});
var SANS_7_8 = (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(8), "px");
        default:
            return "".concat(msW(7), "px");
    }
}, fontCss, sansSerif, (0, mixins_1.mediaQuery)('md'), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(9), "px");
        default:
            return "".concat(msW(8), "px");
    }
});
var SERIF_3 = (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.7em;\n  ", "\n  ", "\n"], ["\n  font-size: ", ";\n  line-height: 1.7em;\n  ", "\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(4), "px");
        default:
            return "".concat(msW(3), "px");
    }
}, fontCss, serif);
var SERIF_3_4 = (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.7em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-size: ", ";\n  line-height: 1.7em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(4), "px");
        default:
            return "".concat(msW(3), "px");
    }
}, fontCss, serif, (0, mixins_1.mediaQuery)('md'), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(5), "px");
        default:
            return "".concat(msW(4), "px");
    }
});
var SERIF_4_5 = (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(5), "px");
        default:
            return "".concat(msW(4), "px");
    }
}, fontCss, serif, (0, mixins_1.mediaQuery)('md'), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(6), "px");
        default:
            return "".concat(msW(5), "px");
    }
});
var SERIF_5_6 = (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(6), "px");
        default:
            return "".concat(msW(5), "px");
    }
}, fontCss, serif, (0, mixins_1.mediaQuery)('md'), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(7), "px");
        default:
            return "".concat(msW(6), "px");
    }
});
var SERIF_6_7 = (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(7), "px");
        default:
            return "".concat(msW(6), "px");
    }
}, fontCss, serif, (0, mixins_1.mediaQuery)('md'), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(8), "px");
        default:
            return "".concat(msW(7), "px");
    }
});
var SERIF_7_8 = (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(8), "px");
        default:
            return "".concat(msW(7), "px");
    }
}, fontCss, serif, (0, mixins_1.mediaQuery)('md'), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(9), "px");
        default:
            return "".concat(msW(8), "px");
    }
});
var SERIF_8_9 = (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-size: ", ";\n  line-height: 1.6em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(9), "px");
        default:
            return "".concat(msW(8), "px");
    }
}, fontCss, serif, (0, mixins_1.mediaQuery)('md'), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(10), "px");
        default:
            return "".concat(msW(9), "px");
    }
});
var SERIF_9_10 = (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 1.5em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-size: ", ";\n  line-height: 1.5em;\n  ", "\n  ", "\n  ", " {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(10), "px");
        default:
            return "".concat(msW(9), "px");
    }
}, fontCss, serif, (0, mixins_1.mediaQuery)('md'), function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(11), "px");
        default:
            return "".concat(msW(10), "px");
    }
});
var LABEL = (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  letter-spacing: ", "em;\n  font-size: ", ";\n  color: ", ";\n  line-height: 1.6em;\n  font-weight: 600;\n  text-transform: uppercase;\n  ", "\n"], ["\n  letter-spacing: ", "em;\n  font-size: ", ";\n  color: ", ";\n  line-height: 1.6em;\n  font-weight: 600;\n  text-transform: uppercase;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return ((theme === null || theme === void 0 ? void 0 : theme.lang) === 'hi' ? 0 : 0.1);
}, function (_a) {
    var theme = _a.theme;
    switch (theme === null || theme === void 0 ? void 0 : theme.lang) {
        case 'hi':
            return "".concat(msW(2), "px");
        default:
            return "".concat(msW(0), "px");
    }
}, function (_a) {
    var color = _a.color, invert = _a.invert;
    return (invert ? white : color);
}, sansSerif);
var BLOCKQUOTE = (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  padding: 1.5rem;\n  border-left: 4px solid\n    ", ";\n  ", ";\n  font-style: italic;\n  color: ", ";\n  margin-inline-start: 25px;\n  margin-inline-end: 25px;\n"], ["\n  padding: 1.5rem;\n  border-left: 4px solid\n    ", ";\n  ", ";\n  font-style: italic;\n  color: ", ";\n  margin-inline-start: 25px;\n  margin-inline-end: 25px;\n"])), function (_a) {
    var invert = _a.invert, colors = _a.theme.colors;
    return invert ? greyColor40 : (0, utilsOolib_1.getPrimaryColor100)(colors);
}, SERIF_4_5, greyColor80);
exports.typo = {
    serif: serif,
    sansSerif: sansSerif,
    SANS_0: SANS_0,
    SANS_2: SANS_2,
    SANS_3: SANS_3,
    SANS_3_4: SANS_3_4,
    LABEL: LABEL,
    SANS_4: SANS_4,
    SERIF_3_4: SERIF_3_4,
    SERIF_3: SERIF_3,
    SERIF_5_6: SERIF_5_6,
    SERIF_9_10: SERIF_9_10,
    SERIF_4_5: SERIF_4_5,
    SERIF_6_7: SERIF_6_7,
    SERIF_7_8: SERIF_7_8,
    SERIF_8_9: SERIF_8_9,
    SANS_4_5: SANS_4_5,
    SANS_7_8: SANS_7_8,
    SANS_5_6: SANS_5_6,
    BLOCKQUOTE: BLOCKQUOTE,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;
